<template>
    <div>
        <div class="channel">
            <!-- <div class="title">{{channelTitle}}渠道提报</div>
            <div class="type-tab">
                <el-tabs  type="card" @tab-click="handleClick" :value="getActiveName(tabArr)" >
                    <el-tab-pane 
                        v-for="(item) in tabArr"   
                        :key="item.themeStyleCode "
                        :label="item.themeStyleName" 
                        :name="item.themeStyleName"
                        >
                        <span slot="label" v-if="item.data.length == 1">
                            <span class="sapn-box">
                                <span>{{item.themeStyleName}}</span>
                                <el-tooltip
                                v-if="isAllbtn && (item.data[0].gpActivityInfoVOList !== null)"
                                class="tooltip-item"
                                effect="dark"
                                :content="item.themeStyleName + '需进行操作'"
                                transition
                                placement="bottom-start">
                                    <div class="circular-red"></div>
                                </el-tooltip>
                            </span>
                        </span>
                        <span slot="label" v-if="item.data.length == 2">
                            <span class="sapn-box">
                                <span>{{item.themeStyleName}}</span>
                                <el-tooltip
                                v-if="isAllbtn && (item.data[0].gpActivityInfoVOList !== null || item.data[1].gpActivityInfoVOList !== null)"
                                class="tooltip-item"
                                effect="dark"
                                :content="item.themeStyleName + '需进行操作'"
                                transition
                                placement="bottom-start">
                                    <div class="circular-red"></div>
                                </el-tooltip>
                            </span>
                        </span>
                        <span slot="label" v-if="item.data.length == 3">
                            <span class="sapn-box">
                                <span>{{item.themeStyleName}}</span>
                                <el-tooltip
                                v-if="isAllbtn && (item.data[0].gpActivityInfoVOList !== null || item.data[1].gpActivityInfoVOList !== null || item.data[2].gpActivityInfoVOList !== null)"
                                class="tooltip-item"
                                effect="dark"
                                :content="item.themeStyleName + '需进行操作'"
                                transition
                                placement="bottom-start">
                                    <div class="circular-red"></div>
                                </el-tooltip>
                            </span>
                        </span>
                        <div class="child" v-if="item.data[0].themeDetail.themeLevelCode !==null">
                            <el-tabs  v-model="activeName" tab-position="left" @tab-click="handleClickson" >
                                <el-tab-pane 
                                    v-for="(i,iIndex) in item.data" 
                                    :key="i.themeDetail.themeLevelCode" 
                                    :label="i.themeDetail.themeLevelName" 
                                    :name="i.themeDetail.themeLevelName"                                         >
                                    <span slot="label">
                                        <span class="sapn-box">
                                            <span>{{i.themeDetail.themeLevelName}}</span>
                                            <el-tooltip
                                            v-if="isAllbtn  && i.gpActivityInfoVOList !== null"
                                            class="tooltip-item"
                                            effect="dark"
                                            :content="i.themeDetail.themeLevelName + '需进行操作'"
                                            transition
                                            placement="bottom-start">
                                                <div class="circular-red-2"></div>
                                            </el-tooltip>
                                        </span>
                                    </span>
                                    <PopForm 
                                    :popDataitem="i"
                                    :isAllbtn = 'isAllbtn'
                                    :queryCondition="queryCondition"
                                    @passThrough ='passThrough'
                                    @sendBack = 'sendBack'
                                    @clickStorename = 'clickStorename'
                                    ></PopForm>
                                </el-tab-pane>
                            </el-tabs>                                       
                        </div>
                        <div class="father" v-else>
                            <PopForm 
                            :popDataitem="item"
                            :isAllbtn = 'isAllbtn'
                            :queryCondition="queryCondition"
                            @passThrough ='passThrough'
                            @sendBack = 'sendBack'
                            @clickStorename = 'clickStorename'
                            ></PopForm>
                        </div>                              
                    </el-tab-pane>
                </el-tabs>
            </div> -->
            <div class="title" style="margin-top: 20px;">
                <i  @click="collClick('orderShow1')" style="cursor: pointer;" :class="[orderShow1 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                <span  @click="collClick('orderShow1')" style="cursor: pointer;">提报售点</span>
            </div>
            <PopForm
            v-show="orderShow1"
            :popDataitem="dataItem"
            :isAllbtn = 'isAllbtn'
            :queryCondition="queryCondition"
            @passThrough ='passThrough'
            @sendBack = 'sendBack'
            @clickStorename = 'clickStorename'
            ></PopForm>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import PopForm from './submit-approval-pop-form.vue'
    export default {
      name: 'submit-approval-pop',
      props: {
        channelForm:{type:Object, default:()=>{} },
        dataForm:{type:Array,default:()=>[]},
        isAllbtn:{type:Boolean,default:true},
        queryCondition:{type:String},
        dataItem:{type:Object, default:()=>{} },
      },
      components: {
        PopForm
      },
      data () {
        return {
            multipleSelection: [],
            
            tabList:[],
            tabName:'地标',
            childName:'',
            tabArr: [],
            activeName: '',
            tabIndex: '',
            channelTitle:'',
            itemData: '',
            allList:[],
            isFatherred : true,
            isSonred: true,
            orderShow1: true
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        // this.init()
      },
      mounted () {
        // const tab = {index: 0}
        // this.handleClick(tab)
      },
      updated () {},
      methods: {
        init () {
            if (this.dataForm.length > 0) {
                this.getChannelitem()
            }
            // this.getAllList()
        },
        collClick (name) {
        if (name == 'orderShow1') {
            this.orderShow1 = !this.orderShow1
        } else if (name == 'orderShow2') {
            this.orderShow2 = !this.orderShow2
        } else if (name == 'orderShow3') {
            this.orderShow3 = !this.orderShow3
        } else if (name == 'orderShow4') {
            this.orderShow4 = !this.orderShow4
        } else if (name == 'orderShow5') {
            this.orderShow5 = !this.orderShow5
        }
        },
        getChannelitem () {
            this.channelTitle = this.channelForm.themeChannelEnName
            let code = this.channelForm.themeChannelCode
            let itemList = []
            for (let i = 0; i < this.dataForm.length; i++) {
                if (code === this.dataForm[i].themeDetail.themeChannelCode) {
                        itemList.push({
                            'themeDetail':this.dataForm[i].themeDetail,
                            'gpActivityInfoVOList':this.dataForm[i].gpActivityInfoVOList
                        })
            }}
            this.allList = itemList
            this.getTaball(this.allList)
        },
        getAllList () {
            let itemIndex = []
            for (let item of this.allList) {
                let index = itemIndex.indexOf(item.themeDetail.themeStyleCode)
                if (index === -1) {
                    itemIndex.splice(0,0,item.themeDetail.themeStyleCode)
                    let data = [
                        {
                        'themeLevelCode':item.themeDetail.themeLevelCode,
                        'themeStyleName':item.themeDetail.themeStyleName,
                        'themeStyleCode':item.themeDetail.themeStyleCode,
                        'themeDetail':item.themeDetail,
                        'gpActivityInfoVOList':item.gpActivityInfoVOList
                        }
                    ]
                    this.tabArr.push(data)
                    
                } else {
                    this.tabArr[index].push(
                        {
                            'themeLevelCode':item.themeDetail.themeLevelCode,
                            'themeStyleName':item.themeDetail.themeStyleName,
                            'themeStyleCode':item.themeDetail.themeStyleCode,
                            'themeDetail':item.themeDetail,
                            'gpActivityInfoVOList':item.gpActivityInfoVOList
                        }
                    )
                }  
            }
            this.tabList =  this.tabArr.map((item)=>{
                return item.themeStyleName || item[0].themeDetail.themeStyleName
            }).join('、')
        },
        getTaball (arr) {
            let map = {}
            let dest = [];
            for(let i = 0; i < arr.length; i++){
                let ai = arr[i];
                if(!map[ai.themeDetail.themeStyleCode]){
                    dest.push({
                        'themeStyleCode': ai.themeDetail.themeStyleCode,
                        'themeStyleName': ai.themeDetail.themeStyleName,
                        'themeLevelCode':ai.themeDetail.themeLevelCode,
                        'themeLevelName':ai.themeDetail.themeLevelName,
                        // 'themeBasic':this.themeBasic,
                        data: [ai]
                    });
                    map[ai.themeDetail.themeStyleCode] = ai;
                }else{
                    for(let j = 0; j < dest.length; j++){
                        let dj = dest[j];
                        if(dj.themeStyleCode == ai.themeDetail.themeStyleCode){
                            dj.data.push(ai);
                            break;
                        }
                    }
                }
            }
            // console.log(dest,'dest');
            this.tabArr = dest
            this.tabList =  this.tabArr.map((item)=>{
                return item.themeStyleName
            }).join('、')
            return dest
        },
        clickStorename (row) {
            this.$emit("clickStorename",row)
        },
        // 通过
        passThrough (item) {
            this.isFatherred = false
            this.isSonred = false
            this.$emit("passThrough",item)
        },
        // 退回
        sendBack (item) {
            this.$emit("sendBack",item)
        },
        getActiveName(tabArr) {
            if (tabArr[0].data[0].themeDetail.themeLevelCode !==null) {
                this.activeName = tabArr[0].data[0].themeDetail.themeLevelName
                return tabArr[0].themeStyleName
            } else {
                return tabArr[0].themeStyleName
            }         
        },
        handleClick(tab) {
            let num = Number(tab.index)
            this.tabIndex = num
            if (this.tabArr[num].data[0].themeDetail.themeLevelCode !==null) {
                this.activeName = this.tabArr[num].data[0].themeDetail.themeLevelName
                return this.tabArr[num].themeStyleName
            } else {
                return this.tabArr[num].themeStyleName
            }
        },
        handleClickson (tab) {
            // console.log(tab,'son');
            // let num = Number(tab.index)
            // let tabName = this.tabArr[this.tabIndex][num].themeDetail.themeLevelName
            // this.activeName =  tabName
            // console.log(this.activeName,'son');
        }     
    }
}
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .channel {
        // margin-top: 30px;
        .title {
            height: 40px;
            line-height: 40px;
            text-align: left;
            color: rgba(16, 16, 16, 1);
            font-size: 18px;
            font-weight: 600;
        }
        .type-tab {
            margin-top: 20px;
            position: relative;

            ::v-deep .el-tabs__item.is-active {
                background-color: #409EFF;
                color: #FFFFFF;
            }
            ::v-deep .el-tabs__item {
                color: #101010;
                background-color: #FFFFFF;
                // border: 0;
                // width: 190px;
                // height: 42px;
                text-align: center;
                margin-right: 5px;
                min-width: 100px;
                border: none;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
                height: 42px;
                padding: 0px !important;    
            }
            ::v-deep .el-tabs__nav-scroll {
                border-bottom: 0;
            }
            ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
                border: 0;
                margin-bottom: 0;
            }
            ::v-deep .el-tabs__content {
                overflow: hidden;
                position: relative;
                margin-top: -15px;
                background-color: #FFFFFF;
                padding: 20px 0px 0px 0px;
                border-radius: 8px;
                border-top-left-radius: 0px;
            }
            ::v-deep .el-tabs--card>.el-tabs__header {
                border-bottom: 0px solid #E4E7ED;
            }
            .circular-red {
                    position: absolute;
                    top: 0px;
                    right: 0px;
                    border-radius: 50%;
                    height: 10px;
                    width: 10px;
                    background-color: #cd1231;
                    z-index: 2;
                }
            .circular-red-2 {
                position: absolute;
                top: 25%;
                right: 25%;
                border-radius: 50%;
                height: 10px;
                width: 10px;
                background-color: #cd1231;
                z-index: 2;
            }    
            .child {
                background-color: #FFFFFF;
                ::v-deep .el-tabs__item.is-active {
                background-color: rgba(255, 255, 255, .1);
                color: #409EFF;
                }
                ::v-deep .el-tabs__item {
                    color: #101010;
                    background-color: rgba(255, 255, 255, .1);
                    // border: 0;
                    // width: 140px;
                    // height: 42px;
                    // border-radius: 4px;
                    text-align: center;
                    // margin-bottom: 10px;
                }
                ::v-deep .el-tabs__nav-scroll {
                    border-bottom: 0;
                }
                ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
                    border: 0;
                    margin-bottom: 0;
                }
            }
        }
    }
</style>
